export default __webpack_public_path__ + "static/media/Harshwardhsn.0f8409ae.png";